import { Flex, HTMLChakraProps } from '@chakra-ui/react';
import { FC } from 'react';

import { ThinEvent } from '@/resources/ThinEvent';
import { AnyProfile } from '@/utils/profileHelpers';

import { HorizontalBar } from './components/HorizontalBar/HorizontalBar';
import { NavigationRail } from './components/NavigationRail/NavigationRail';
import { NavigationRailContent } from './components/NavigationRailContent/NavigationRailContent';

export interface IEventHeaderProps extends HTMLChakraProps<'div'> {
  event: ThinEvent;
  currentUserProfile: AnyProfile;
  onLogout: () => void;
}

// Split by responsibility rather than by screen position: NavigationRail is the drawer's
// mechanics (open/close, focus trap, scroll lock) and knows nothing about pages or accounts;
// NavigationRailContent is that data. Both plus HorizontalBar render as siblings in this one
// flex row, not nested containers - see each component's own comment for why.
export const EventHeader: FC<IEventHeaderProps> = ({ event, currentUserProfile, onLogout, ...rest }) => {
  return (
    <Flex
      as="header"
      position="sticky"
      top="0"
      alignItems="center"
      px={{ base: 4, md: 8, lg: 0 }}
      bgColor="white"
      boxShadow="inset 0 -1px 0 #CCCCCC"
      {...rest}
    >
      <NavigationRail>
        <NavigationRailContent event={event} currentUserProfile={currentUserProfile} onLogout={onLogout} />
      </NavigationRail>
      <HorizontalBar event={event} currentUserProfile={currentUserProfile} onLogout={onLogout} />
    </Flex>
  );
};
